import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Carousel from '~shared/ui/CarouselV2/CarouselV2';
import {
    MADE_FOR_YOU_TYPES,
    I18N_MADE_FOR_YOU_TYPES_MAP,
    MADE_FOR_YOU_FOR_TODAY_TYPE,
    MADE_FOR_YOU_GTM_SWITCHED_TAB_MAP,
} from 'scenes/madeforyou/constants';
import {
    pushActiveTab,
 } from '~scenes/madeforyou/app/actions/mfyActions';
import {
    selectActiveTab,
    selectIsMadeForYouWidget,
    selectTabList,
} from '~scenes/madeforyou/app/selectors/mfySelectors';
import {
    useIsUserLoggedIn,
} from '~SpectateStore/hooks/userHooks';
import i18n from '~shared/utils/i18n';
import { navigatePage } from '~spa/Utils/WrapperIntegration/Ucf';
import { generateMfySeoUrl, getGtmPrefix } from 'scenes/madeforyou/utils';
import { rewriteUrl } from '~shared/utils/uriAliases';

const getLoggedOutTypes = (isWidget = false) => {
    // we don't show won & backed tabs widget if the user is logged out.
    // if it's the main page we show all tabs.
    return isWidget ? [MADE_FOR_YOU_FOR_TODAY_TYPE] : MADE_FOR_YOU_TYPES;
};

const getMfyTabs = (typeList = MADE_FOR_YOU_TYPES, gtmPrefix) => typeList.map((type) => (
    <div
        key={type}
        className='made-for-you__carousel-item'
        data-spectate-product={`${gtmPrefix};${MADE_FOR_YOU_GTM_SWITCHED_TAB_MAP[type]}`}
    >
        {i18n.t(I18N_MADE_FOR_YOU_TYPES_MAP[type])}
    </div>
));

/**
 * Renders the TabsMenu component for the made for you page
 * @returns {React.Element} TabsMenu
 */
const TabsMenu = () => {
    const dispatch = useDispatch();
    const activeTab = useSelector(selectActiveTab);
    const isWidget = useSelector(selectIsMadeForYouWidget);
    const isLoggedIn = useIsUserLoggedIn();
    const tabList = useSelector(selectTabList);
    const gtmPrefix = getGtmPrefix(activeTab, isWidget);

    const mfyTypes = isLoggedIn
        ? tabList
        : getLoggedOutTypes(isWidget);

    useEffect(() => {
        if (!mfyTypes.includes(activeTab)) {
            // Widget should show the tab to the far left selected on load
            // The main page will always be set based on the URL
            dispatch(pushActiveTab(mfyTypes[0]));
        }
    }, [mfyTypes, activeTab]);

    return (
        <Carousel
            key={activeTab}
            jsxItems={getMfyTabs(mfyTypes, gtmPrefix)}
            onItemClick={ (index) => {
                if (isWidget) {
                    dispatch(pushActiveTab(mfyTypes[index]));
                } else {
                    navigatePage(rewriteUrl(generateMfySeoUrl(mfyTypes[index])));
                }
            }}
            extraClass='made-for-you__carousel'
            selectedItemSlugOrId={mfyTypes.indexOf(activeTab)}
            shouldTriggerFirstClick={false}
        />
    );
};

export default TabsMenu;
